import { render, staticRenderFns } from "./TS-quality-widget.vue?vue&type=template&id=0971f968"
import script from "./TS-quality-widget.vue?vue&type=script&lang=js"
export * from "./TS-quality-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports